import React from "react";
import { WSS, WSSMessage, WSSMessageStatus } from "src/utils/wss";

export interface WssState {
    lastMessages: WSSMessage[];
    lastTimestamp: number;
}

const initialState = {
    lastMessages: WSS.getLastMessages(40),
    lastTimestamp: Date.now(),
};

const WssStateContext = React.createContext(initialState) as any;
const WssDispatchContext = React.createContext(initialState) as any;

export const WssActionTypes = {
    SET_MESSAGES: "setMessages",
    SET_ALL_SEEN: "setAllSeen",
};

const wssReducer = (state: WssState, action: { type: string; payload: WssState }) => {
    switch (action.type) {
        case WssActionTypes.SET_MESSAGES: {
            return { ...state, lastMessages: action.payload, lastTimestamp: Date.now() };
        }
        case WssActionTypes.SET_ALL_SEEN: {
            return {
                ...state,
                lastMessages: state.lastMessages.map((lm) => ({
                    ...lm,
                    status: WSSMessageStatus.SEEN,
                })),
            };
        }
        default: {
            throw new Error(`Unhandled action type: ${action.type}`);
        }
    }
};

const WssProvider = ({ children }: any) => {
    const [state, dispatch] = React.useReducer(wssReducer as any, initialState);

    return (
        <WssStateContext.Provider value={state}>
            <WssDispatchContext.Provider value={dispatch}>{children}</WssDispatchContext.Provider>
        </WssStateContext.Provider>
    );
};

const useWssState = (): WssState | null => {
    const wss = React.useContext(WssStateContext) as WssState;

    if (wss === undefined) {
        throw new Error("useWssState must be used within a WssProvider");
    }

    return wss;
};

const useWssDispatch: any = () => {
    const dispatch = React.useContext(WssDispatchContext);

    if (dispatch === undefined) {
        throw new Error("useWssDispatch must be used within a WssProvider");
    }

    return dispatch;
};

export { WssProvider, useWssState, useWssDispatch };
